<template>
  <div>
    <v-chip-group>
      <FiltersButton
        label="Услуга"
        icon="ui-icon-doctor"
        :active-num="serviceFilters.getAppliedNum()"
        :reset-handler="handleServiceFiltersReset"
        @click="openDialog('service')"
      />
      <FiltersButton
        label="Место"
        icon="ui-icon-map-pin"
        :active-num="placeFilters.getAppliedNum()"
        :reset-handler="handlePlaceFiltersReset"
        @click="openDialog('regions')"
      />
      <slot
        name="map-button"
        v-bind="{ classes: ['ml-auto'] }"
      />
    </v-chip-group>

    <service-filters-service
      class="filters-button"
      :active="anyServiceFilterApplied"
      :filters="serviceFilters"
      :open="isTopDialog('service')"
      @filters:submit="handleServiceFiltersSubmit"
      @filters:reset="handleServiceFiltersReset"
      @filters:close="handleServiceFiltersClose"
    />

    <common-filters-place
      class="filters-button ml-4"
      :active="anyPlaceFilterApplied"
      :filters="placeFilters"
      :open="isTopDialog('regions')"
      @filters:submit="handlePlaceFiltersSubmit"
      @filters:reset="handlePlaceFiltersReset"
      @filters:close="handlePlaceFiltersClose"
    />

    <snackbar-notification
      v-model="notification"
      :upper="notificationUpper"
      :message="notificationMessage"
    />
  </div>
</template>

<script>
import DialogManager from 'www/vue_components/common/mixins/DialogManager'
import SnackbarNotification from 'www/vue_components/common/core/SnackbarNotification/SnackbarNotification.vue'
import CommonFiltersPlace from 'www/vue_components/desktop/CommonFilters/CommonFiltersPlace.vue'
import FiltersButton from 'www/vue_components/desktop/CommonFilters/FiltersButton.vue'
import ServiceFiltersMixin from 'www/vue_components/common/ServiceFilters/mixins/ServiceFiltersMixin'
import ServiceFiltersService from './ServiceFiltersService.vue'

export default {
  name: 'ServiceFilters',
  components: {
    FiltersButton,
    ServiceFiltersService,
    CommonFiltersPlace,
    SnackbarNotification,
  },
  mixins: [
    DialogManager,
    ServiceFiltersMixin,
  ],
}
</script>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/variables';

.filters-button {
  flex: 0 1 268px;
}
</style>
